'use strict';

/**
 * @module City
 * @author Philip & Micha
 */

const BaseView = require('./_');
const CityTemplate = require('../../templates/city.html');
const TemplateHelper = require('../helpers/template');
const ConfigurationHelper = require('../helpers/configuration');
const EventHelper = require('../helpers/event');

class City extends BaseView {
	constructor (parent, city) {
		super({
			parent
		});
		this.city = city;
	}

	render () {
		TemplateHelper.render({
			view: this,
			template: CityTemplate,
			data: {
				city: this.city,
				label: this.city.placeCount + ' ' + (this.city.placeCount === 1 ? ConfigurationHelper.getString('list.city.station.single') : ConfigurationHelper.getString('list.city.station.mulitple')),
				isTopCity: this.city.placeCount > ConfigurationHelper.getTopCityThreshold()
			}
		});
	}
	
	select () {
		EventHelper.selectCity(this.city);
	}
	
	updateOrder (order) {
		this.city.order = order;
	}
}

module.exports = City;
